import { Injectable } from '@angular/core'

import { IProduct } from '../../models/product'
import { UtilityService } from '../utility-service/utility-service.service'
import { ClassificationRulesService } from './classification-rules.service'

@Injectable({
  providedIn: 'root',
})
export class ClassificationRulesEquityService {
  // Equity
  static isUSEquity(product: IProduct) {
    return (
      ClassificationRulesService.isRelevant(product) &&
      ClassificationRulesService.isEquity(product) &&
      UtilityService.wordMatch(
        product.regionOfInvestment,
        'Country of Domicile',
      )
    )
  }

  static isLargeCapEquity(product: IProduct) {
    return (
      ClassificationRulesService.isRelevant(product) &&
      ClassificationRulesService.isEquity(product) &&
      (UtilityService.wordMatch(product.equityStyleBoxSize, 'Large Cap') ||
        UtilityService.wordMatch(product.industryCategory, 'Large Blend'))
    )
  }

  static isIntlEquity(product: IProduct) {
    return (
      ClassificationRulesService.isRelevant(product) &&
      ClassificationRulesService.isEquity(product) &&
      (UtilityService.wordMatch(product.regionOfInvestment, 'International') ||
        UtilityService.wordMatch(product.regionOfInvestment, 'Global'))
    )
  }

  static isDevelopedEquity(product: IProduct) {
    return (
      ClassificationRulesService.isRelevant(product) &&
      ClassificationRulesService.isEquity(product) &&
      !this.isEmergingEquity(product)
    )
  }

  static isEmergingEquity(product: IProduct) {
    return (
      ClassificationRulesService.isRelevant(product) &&
      ClassificationRulesService.isEquity(product) &&
      UtilityService.wordMatch(
        product.industryCategory,
        'Diversified Emerging Markets',
      )
    )
  }

  static isGlobalEquity(product: IProduct) {
    return (
      ClassificationRulesService.isRelevant(product) &&
      ClassificationRulesService.isEquity(product) &&
      UtilityService.existAnyWordMatch(product.foiTypes, 'global')
    )
  }

  static isNonUSEquity(product: IProduct) {
    return (
      ClassificationRulesService.isRelevant(product) &&
      ClassificationRulesService.isEquity(product) &&
      UtilityService.existAnyWordMatch(product.foiTypes, 'nonUS')
    )
  }

  // eslint-disable-next-line complexity
  static isMidCapEquity(product: IProduct) {
    return (
      ClassificationRulesService.isRelevant(product) &&
      ClassificationRulesService.isEquity(product) &&
      (UtilityService.wordMatch(product.equityStyleBoxSize, 'Medium Cap') ||
        (UtilityService.wordMatch(product.industryCategory, 'Mid Blend') &&
          product.managementStrategy === 'Index' &&
          product.fundIndicator === 'Fund of Fund' &&
          product.productTypeLevel2 === 'Collective Investment Trust (CIT)'))
    )
  }

  static isSmallCapEquity(product: IProduct) {
    return (
      ClassificationRulesService.isRelevant(product) &&
      ClassificationRulesService.isEquity(product) &&
      UtilityService.wordMatch(product.equityStyleBoxSize, 'Small Cap')
    )
  }

  static isIndexEquity(product: IProduct) {
    return (
      ClassificationRulesService.isRelevant(product) &&
      ClassificationRulesService.isEquity(product) &&
      (product.managementStrategy === 'Index' ||
        product.managementStrategy === 'Index-Oriented')
    )
  }

  static isActiveEquity(product: IProduct) {
    return (
      ClassificationRulesService.isRelevant(product) &&
      ClassificationRulesService.isEquity(product) &&
      product.managementStrategy === 'Active'
    )
  }

  static isBlendEquity(product: IProduct) {
    return (
      ClassificationRulesService.isRelevant(product) &&
      ClassificationRulesService.isEquity(product) &&
      UtilityService.wordMatch(product.equityStyleBoxStyle, 'Blend/Core')
    )
  }

  static isGrowthEquity(product: IProduct) {
    return (
      ClassificationRulesService.isRelevant(product) &&
      ClassificationRulesService.isEquity(product) &&
      UtilityService.wordMatch(product.equityStyleBoxStyle, 'Growth') &&
      !ClassificationRulesEquityService.isESGStrategiesEquity(product)
    )
  }

  static isESGStrategiesEquity(product: IProduct) {
    return (
      ClassificationRulesService.isRelevant(product) &&
      ClassificationRulesService.isEquity(product) &&
      UtilityService.wordMatch(
        product.fundGroupSociallyResponsibleFunds,
        'Socially Responsible Investment Funds',
      )
    )
  }

  static isValueEquity(product: IProduct) {
    return (
      ClassificationRulesService.isRelevant(product) &&
      ClassificationRulesService.isEquity(product) &&
      UtilityService.wordMatch(product.equityStyleBoxStyle, 'Value')
    )
  }
}
